const serviceType = {
  SEARCH_IHI: "searchIHI",
  SEARCH_FOR_PROVIDER_INDIVIDUAL: "searchForProviderIndividual"
};

export default serviceType;
